import EventTesting from 'modules/events/components/EventTesting/EventTesting';

const EventTestingGroup = () => {
  return (
    <EventTesting />
  );
};

export default EventTestingGroup;
